import React from 'react';
import {
  PieChart,
  Pie,
  Cell,
  Tooltip as RechartsTooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import ChartCard from './ChartCard';
import { COLORS } from './constants';
import { PaymentModeItem } from './types';

interface PaymentModeChartProps {
  data: PaymentModeItem[];
}

const PaymentModeChart: React.FC<PaymentModeChartProps> = ({ data }) => (
  <ChartCard title="Payment Mode Distribution" timeout={1800} minHeight={{ xs: 240, md: 300 }}>
    <ResponsiveContainer width="100%" height="100%">
      <PieChart>
        <Pie
          data={data}
          cx="50%"
          cy="50%"
          labelLine={false}
          outerRadius={80}
          fill="#8884d8"
          dataKey="value"
        >
          {COLORS.map((color, index) => (
            <Cell key={`cell-${index}`} fill={color} />
          ))}
        </Pie>
        <RechartsTooltip />
        <Legend />
      </PieChart>
    </ResponsiveContainer>
  </ChartCard>
);

export default PaymentModeChart;
